import {
    BlobReader,
    BlobWriter,
    ZipReader
} from '@zip.js/zip.js'

export class PururinUpload {
    constructor(file, serverUrl) {
        this.file = file;
        this.serverUrl = serverUrl;
        this.total = 0;
        this.maxConcurrency = 4;
        this.currentConcurrency = 0;
        this.uploadQueue = [];
        this.files = [];
        this.imagePaths = {
            directory: null,
            images: [],
        };
        this.eventHandlers = {};
        this.progress = {
            total: 0,
            totalBytes: 0,
        }
    }

    /**
     * Run
     * @return void
     */
    Run() {
        try {
            this.getEntries().then(entries => {
                var sortEntries = this.sort(entries),
                    i = 0;
                // Loop
                sortEntries.forEach((entry) => {
                    // Check if directory
                    if (entry.directory) return;
                    // Check if image
                    if (!(entry.filename.toLowerCase().endsWith('.jpg') ||
                            entry.filename.toLowerCase().endsWith('.png') ||
                            entry.filename.toLowerCase().endsWith('.jpeg') ||
                            entry.filename.toLowerCase().endsWith('.gif') ||
                            entry.filename.toLowerCase().endsWith('.webp') ||
                            entry.filename.toLowerCase().endsWith('.wbmp'))) return;

                    // Add to files
                    this.files.push({
                        name: entry.filename,
                        size: entry.uncompressedSize || entry.compressedSize,
                    })
                    // Push to uploadQueue
                    this.uploadQueue.push({
                        entry: entry,
                        index: i,
                    })
                    i++;
                });
                // Get total of upload queue
                this.total = this.uploadQueue.length;
                // Check process queue
                if (this.total == 0) {
                    this.trigger('error', {
                        message: 'There\'s nothing to process, no images found on the zip file. (Allowed extensions are .jpg, .png, .jpeg, .gif)',
                    })
                    return;
                }
                // trigger progess
                this.trigger('progress', {
                    totalImages: this.total,
                    totalUploaded: this.progress.total,
                })
                // Process queue once done
                for (var j = 0; j < this.maxConcurrency; j++) {
                    this.processQueue();
                }
            }).catch(e => {
                this.trigger('error', {
                    message: e.message,
                })
            })
        } catch (e) {
            this.trigger('error', {
                message: 'There\'s nothing to process, no images found on the zip file.',
            })
        }
    }

    /**
     * uploadImage
     * Upload the image to the server
     * @return Promise
     */
    async uploadImage(blob, index, isGif = false) {
        var formData = new FormData();
        formData.append('file', blob);
        formData.append('hash', this.getHash());
        formData.append('index', index);
        if (isGif) formData.append('gif', true);

        // Return axios
        return axios.post(this.serverUrl, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        });
    }

    /**
     * processQueue
     * Process the upload queue
     * @return void
     */
    async processQueue() {
        // Check  upload queue
        if (this.uploadQueue.length == 0) return;
        // Check concurrency
        if (this.currentConcurrency >= this.maxConcurrency) return;
        // Get queue
        var queue = this.uploadQueue.shift();
        // Increase currect Concurrency
        this.currentConcurrency++;
        // Get the data from the entry
        await this.extractFile(queue.entry).then(blob => {
            return this.uploadImage(blob, queue.index, queue.entry.filename.toLowerCase().endsWith('.gif'));
        }).then((resp) => {
            // Add to path
            this.imagePaths.directory = resp.data.directoryPath;
            this.imagePaths.images.push({
                page: resp.data.page,
                filename: resp.data.fileName,
            })
            // Increase progress
            this.progress.total += 1;
            this.progress.totalBytes += queue.entry.size;
            // trigger progess
            this.trigger('progress', {
                totalImages: this.total,
                totalUploaded: this.progress.total,
            })
            // Check if uploaded all
            if (this.progress.total === this.total) {
                this.trigger('success', {
                    message: 'Uploaded',
                    totalImages: this.total,
                    totalUploaded: this.progress.total,
                    imagePaths: this.imagePaths,
                })
            }
            // Decrease current concurrency
            this.currentConcurrency--;
            // Re-call
            this.processQueue();
        }).catch(e => {
            this.trigger('error', {
                message: e.message,
            })
        })
    }
    /**
     * getEntries
     * Get Zip Entries
     * @return List<entry>
     */
    async getEntries() {
        const zipFileReader = new BlobReader(this.file);
        const zipReader = new ZipReader(zipFileReader);
        return zipReader.getEntries();
    }

    /**
     * extractFile
     * Extract a file from Zip file
     * @return Promise<blob>
     */
    async extractFile(entry) {
        return entry.getData(new BlobWriter());
    }

    /**
     * sort
     * Sort the entry like windows does
     * @return List<entry>
     */
    sort(entries) {
        return entries.sort((a, b) => {
            var pattern = /(\d+)|(\D+)/g;
            var aMatches = a.filename.match(pattern);
            var bMatches = b.filename.match(pattern);

            while (aMatches && bMatches) {
                var aChunk = aMatches.shift();
                var bChunk = bMatches.shift();

                if (aChunk !== bChunk) {
                    var aNumber = parseInt(aChunk);
                    var bNumber = parseInt(bChunk);

                    if (!isNaN(aNumber) && !isNaN(bNumber)) {
                        return aNumber - bNumber;
                    } else {
                        return aChunk.localeCompare(bChunk);
                    }
                }
            }
            if (aMatches) {
                return 1;
            } else if (bMatches) {
                return -1;
            } else {
                return a.localeCompare(b);
            }
        });
    }

    /**
     * getHash
     * @return string
     */
    getHash() {
        return $('input[name="hash"]').val();
    }

    /**
     * getImagePaths
     * @return Object
     */
    getImagePathData() {
        return this.imagePaths;
    }

    /**
     * Get Total Pages
     * @return Int
     */
    getTotal() {
        return this.total;
    }

    /**
     * Get Files Info
     * @return array
     */
    getFilesInfo() {
        return this.files;
    }

    /**
     * On
     * @param {*} eventName
     * @param {*} handler
     */
    on(eventName, handler) {
        if (!this.eventHandlers[eventName]) {
            this.eventHandlers[eventName] = [];
        }
        this.eventHandlers[eventName].push(handler);
    }

    /**
     *  trigger
     * @param {*} eventName
     * @param {*} data
     */
    trigger(eventName, data) {
        const handlers = this.eventHandlers[eventName];
        if (handlers) {
            handlers.forEach(handler => handler(data));
        }
    }
}
